import {closeModal, MODAL_IDS, openModal} from '@Components/modal-container-deprecated';
import type {CropperPanelProps} from '@Panels/cropper-panel';
import type {MessageModalProps} from '@Modals/message-modal';
import {closeMessageModal, openMessageModal} from '@Modals/message-modal';
import {openChangePlanModal} from '@Modals/change-plan-modal';
import type {MaskingModalProps} from '@Modals/masking-modal';
import {openMaskingModal} from '@Modals/masking-modal';
import type {CompleteSignupModalProps} from '@Modals/complete-signup-modal';
import {closeCompleteSignupModal, openCompleteSignupModal} from '@Modals/complete-signup-modal';
import type {ConnectSSOAccountPanelProps} from '@Panels/connect-sso-account-panel';
import {openConnectSSOAccountModal} from '@Modals/connect-sso-account-modal';
import {closeTwoFactorAuthenticationVerificationModal, openTwoFactorAuthenticationVerificationModal} from '@Modals/two-factor-authentication-verification-modal/two-factor-authentication-verification-modal.library';
import type {ManageTwoFactorAuthenticationModalProps} from '@Modals/manage-two-factor-authentication-modal';
import {openManageTwoFactorAuthenticationModal} from '@Modals/manage-two-factor-authentication-modal/manage-two-factor-authentication-modal.library';
import type {PasswordVerificationPanelProps} from '@Panels/password-verification-panel/password-verification-panel.types';
import {openPasswordVerificationModal} from '@Modals/password-verification-modal/password-verification-modal.library';
import type {TwoFactorAuthenticationVerificationPanelProps} from '@Panels/two-factor-authentication-verification-panel/two-factor-authentication-verification-panel.types';
import {openAccountDeletionModal} from '@Modals/account-deletion-modal/account-deletion-modal-library';
import type {AccountDeletionModalProps} from '@Modals/account-deletion-modal/account-deletion-modal.types';
import type {ErrorModalProps} from '@Modals/error-modal';
import {openErrorModal} from '@Modals/error-modal';
import type {ConfirmationModalProps} from '@Modals/confirmation-modal';
import {openConfirmationModal} from '@Modals/confirmation-modal';
import {openCropperModal} from '@/components/modals/cropper-modal/cropper-modal.library';
import {openCancelSubscriptionModal} from '@Modals/cancel-subscription-modal/cancel-subscription-modal.library';
import type {CancelSubscriptionPanelProps} from '@Panels/cancel-subscription-panel/cancel-subscription-panel.types';
import {openPermissionDeniedPanel} from '@Panels/share-panel/share-panel-library';
import {openPersonaModal} from '@Modals/persona-modal/persona-modal.library';
import {openPremiumPricingModal} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import type {PersonaPanelProps} from '@Panels/persona-panel/persona-panel.types';
import {openAuthenticateModal} from '@Modals/authenticate-modal/authenticate-modal-library';
import type {DownloadModalProps} from '@Modals/download-modal/download-modal.library';
import {openNewDownloadModal} from '@Modals/download-modal/download-modal.library';
import {openConfirmDeleteModal} from '@Modals/confirm-delete-modal/confirm-delete-modal.types';
import type {ConfirmDeletePanelProps} from '@/components/panels/confirm-delete-panel/confirm-delete-panel.types';

window.PMW.mergePMW(PMW, {
  openErrorModal(props: ErrorModalProps) {
    openErrorModal(props);
  },

  openMessageModal(props: MessageModalProps) {
    openMessageModal(props);
  },

  closeMessageModal() {
    closeMessageModal();
  },

  openCropperModal(props: CropperPanelProps) {
    openCropperModal(props);
  },

  /**
   * Closes the modal
   * @param {string} id
   */
  closeModal(id: string) {
    if (!Object.values(MODAL_IDS).includes(id)) {
      return;
    }

    closeModal(id);
  },

  openConfirmDeleteModal(props: ConfirmDeletePanelProps) {
    openConfirmDeleteModal(props);
  },

  /**
   *
   * @param {Object} [options]
   * @param {string} [options.modalTitle]
   * @param {string} [options.modalClasses]
   * @param {Object} [options.modalContent]
   * @param {boolean} [options.closeOnModalBodyClick]
   *
   */
  openMenuListModal(options = {}) {
    openModal(MODAL_IDS.MENU_LIST_MODAL, options);
  },

  async openChangePlanModal() {
    if (await window.PMW.showSubscriptionHandlingInfo()) {
      return;
    }
    openChangePlanModal();
  },

  openMaskingModal(options: MaskingModalProps) {
    openMaskingModal(options);
  },

  openConnectSSOAccountModal(options: ConnectSSOAccountPanelProps) {
    openConnectSSOAccountModal(options);
  },

  openTwoFactorAuthenticationVerificationModal(options: TwoFactorAuthenticationVerificationPanelProps) {
    openTwoFactorAuthenticationVerificationModal(options);
  },

  closeTwoFactorAuthenticationVerificationModal() {
    closeTwoFactorAuthenticationVerificationModal();
  },

  openPasswordVerificationModal(options: PasswordVerificationPanelProps) {
    openPasswordVerificationModal(options);
  },

  openManageTwoFactorAuthenticationModal(options: ManageTwoFactorAuthenticationModalProps) {
    openManageTwoFactorAuthenticationModal(options);
  },

  /**
   * @param opts
   */
  openCompleteSignupModal(opts: CompleteSignupModalProps) {
    openCompleteSignupModal(opts);
  },

  closeCompleteSignupModal() {
    closeCompleteSignupModal();
  },

  openAccountDeletionModal(options: AccountDeletionModalProps) {
    openAccountDeletionModal(options);
  },

  openConfirmationModal(options: ConfirmationModalProps) {
    openConfirmationModal(options);
  },

  async openCancelSubscriptionModal(params: CancelSubscriptionPanelProps) {
    if (await window.PMW.showSubscriptionHandlingInfo()) {
      return;
    }
    openCancelSubscriptionModal(params);
  },

  openFolderSharePermissionDeniedModal() {
    openPermissionDeniedPanel(window.i18next.t('pmwjs_folder_invite_permission_denied_message'));
  },

  openPersonaModal(params: PersonaPanelProps) {
    openPersonaModal(params);
  },

  openPremiumPricingModal(isTrial: boolean, upsellFeatureName?: string) {
    openPremiumPricingModal(isTrial, upsellFeatureName);
  },

  openAuthenticateModal(onLoginSuccess: () => Promise<void>) {
    openAuthenticateModal({onLoginSuccess: onLoginSuccess});
  },

  openNewDownloadModal(props: DownloadModalProps) {
    openNewDownloadModal(props);
  },
});
